import { Box } from "@mui/material";

const UserImage = ({ image, size = "60px", codigoOperador }) => {
  const avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(
    codigoOperador || "Usuario"
  )}&background=1e40af&color=fff`;
  return (
    <Box width={size} height={size}>
      <img
        style={{ objectFit: "cover", borderRadius: "50%" }}
        width={size}
        height={size}
        alt="user"
        src={avatarUrl}
      />
    </Box>
  );
};

export default UserImage;
